"use client"

import { Button, Typography } from "@mui/material"

const NotFound = (props: any) => {
  return (
    <form
      style={{
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        height: "100%",
        backgroundImage: "url('/pexels-andrew-2312369.jpg')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom",
        backgroundSize: "cover"
      }}
    >
      <div className="bg-black h-full w-full sm:w-[50%] mr-5 p-10 flex flex-col gap-8 text-white">
        <Typography variant="h1" className="">
          ¡Ups!
        </Typography>

        <Typography variant="h5">La página que estás buscando no existe o no tienes acceso.</Typography>

        <Button variant="outlined" color="info" className="w-fit" href="/">
          Volver
        </Button>
      </div>
    </form>
  )
}

export default NotFound
